import type { ProgramDetail } from "./program-records";
import { ProgramResults } from "./program-results";
import s from "../onepager.module.css";
const percent = new Intl.NumberFormat("en", { style: "percent" });
function day(iso: string): string {
  return new Date(iso).toLocaleDateString("en", {
    month: "short",
    day: "numeric",
  });
}

export function ProgramFacts({
  detail,
  coworld,
}: {
  readonly detail: ProgramDetail;
  readonly coworld: string;
}) {
  return (
    <dl className={s.programFacts}>
      {detail.author ? (
        <>
          <dt>By</dt>
          <dd>{detail.author}</dd>
        </>
      ) : null}
      {detail.version !== null ? (
        <>
          <dt>Version</dt>
          <dd>
            v{detail.version}
            {detail.releasedAt ? `, made ${day(detail.releasedAt)}` : ""}
          </dd>
        </>
      ) : null}
      <dt>Rating</dt>
      <dd>{ratingText(detail.rating)}</dd>
      {detail.source ? (
        <>
          <dt>Public source</dt>
          <dd>
            {detail.source.kind === "file" ? (
              <a href={detail.source.download} download>
                {coworld}&apos;s {detail.source.player} program (download)
              </a>
            ) : (
              <a href={detail.source.href} target="_blank" rel="noreferrer">
                {coworld}&apos;s {detail.source.player} program ↗
              </a>
            )}
          </dd>
        </>
      ) : null}
      {detail.sourceHref ? (
        <>
          <dt>Source</dt>
          <dd>
            <a href={detail.sourceHref} target="_blank" rel="noreferrer">
              {detail.sourceHref.replace(/^https?:\/\//, "")} ↗
            </a>
          </dd>
        </>
      ) : null}
      <dt>Last games</dt>
      <dd>
        <ProgramResults results={detail.results} />
      </dd>
    </dl>
  );
}

function ratingText(rating: ProgramDetail["rating"]): string {
  if (!rating) return "not on the leaderboard";

  const parts = [
    `rank ${rating.rank}`,
    `${rating.scoreLabel} ${rating.score.toFixed(1)}`,
  ];

  if (rating.winRate !== null)
    parts.push(`${percent.format(rating.winRate)} won`);

  if (rating.games !== null) parts.push(`${rating.games} games`);

  return parts.join(" · ");
}
